import { Injectable } from '@angular/core';
import { serverPort, base_url } from "../../../server/src/config/config";
import { AccountBooking } from "../models/AccountBooking";
import { Http, Response } from "@angular/http";

@Injectable()
export class AccountBookingService {

  constructor(private http: Http) {
  }

  create(account_booking: AccountBooking) {
    return this.http.post(`${base_url}/v1/account_bookings`, account_booking).map((response: Response) => response.json());
  }

  list() {
    return this.http.get(`${base_url}/v1/account_bookings`).map((response: Response) => response.json());
  }

  getById(_id) {
    return this.http.get(`${base_url}/v1/account_bookings?_id=${_id}`).map((response: Response) => response.json());
  }

  getUnPaidRecord(obj) {
    return this.http.post(`${base_url}/v1/account_bookings_unpaid`, obj).map((response: Response) => response.json());
  }

  getAccountBookingById(_id) {
    return this.http.get(`${base_url}/v1/account_bookings?account=${_id}`).map((response: Response) => response.json());
  }

  putById(_id, account_booking: AccountBooking) {
    return this.http.put(`${base_url}/v1/account_bookings/${_id}`, account_booking).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/services/account-booking.service.ts